import * as React from "react";
import { connect } from "react-redux";
import {reset} from "redux-form";
import { RootState } from "../../redux";
import { fetchForCode, login } from "../../redux/modules/appAuth/appAuth";
import MainLogo from "../../components/Logos/MainLogo";
import SimpleWhiteContainer from "../../components/Containers/SimpleWhiteContainer";
import AskForPhone from "../../components/Forms/AskForPhone";
import AskForCode from "../../components/Forms/AskForCode";

const s = require("./login.scss");

export interface Props {
    value: number;
    dispatch: any;
    loginStep: string;
    isSendingCode: boolean;
    isLoggingIn: boolean;
    loginError: string;
    loginData: {
        phone?: string;
    };
}

class Login extends React.Component<Props, {}> {
    handlePhoneSubmit(values: any) {
        let sanitizedPhone = values.phone.replace(/[\s+)(]/g, "");
        console.log(sanitizedPhone);
        this.props.dispatch(reset("AskForPhoneForm"));
        this.props.dispatch(fetchForCode(sanitizedPhone));
    }

    handleCodeSubmit(values: any) {
        let sanitizedCode = values.code.replace(/[\s+)(]/g, "");
        console.log(values);
        this.props.dispatch(reset("AskForCodeForm"));
        this.props.dispatch(login(this.props.loginData.phone, sanitizedCode));
    }

    render() {
        const loginStep = () => {
            switch (this.props.loginStep) {
                case "AskForPhone":
                    return (
                        <div>
                            <h2>Bem vindo!</h2>
                            <p>Para entrar na sua conta, digite o número do seu celular</p>
                            <p>Caso não tenha uma conta, você pode se registrar através dos aplicativos <a href="https://play.google.com/store/apps/details?id=br.net.meumedico" target="_blank">Android</a> ou <a href="https://itunes.apple.com/us/app/meu-medico/id1139028785" target="_blank">IOS</a>.</p>

                            <div className={s.loginContentForm}>
                                {(this.props.isSendingCode ? "Enviando código..." : (
                                    <AskForPhone
                                        onSubmit={this.handlePhoneSubmit.bind(this)}
                                    />
                                ))}
                            </div>
                        </div>
                    );
                case "askForCode":
                return (
                    <div>
                        {(this.props.loginError ? (
                            <p>
                                Código inválido, tente novamente
                            </p>
                        ): (
                            <p>
                                Em instantes você irá receber um código no seu celular
                                <br/>
                                Digite o código no campo abaixo para continuar
                            </p>
                        ))}


                        <div className={s.loginContentForm}>
                            {(this.props.isLoggingIn ? "Verificando código..." : (
                                <AskForCode
                                    onSubmit={this.handleCodeSubmit.bind(this)}
                                />
                            ))}
                        </div>
                    </div>
                );
                default:
                    return (
                        <div>Página errada :(</div>
                    );
            }
        };

        return (
            <div className={s.login}>
                <div className={s.logo}>
                    <MainLogo/>
                </div>

                <SimpleWhiteContainer>
                    <div className={s.loginContent}>
                        {loginStep()}
                    </div>
                </SimpleWhiteContainer>
            </div>
        );
    }
}

const mapStateToProps = (state: RootState) => {
    return {
        loginStep: state.appAuth.loginStep,
        isSendingCode: state.appAuth.isSendingCode,
        loginData: state.appAuth.loginData,
        isLoggingIn: state.appAuth.isLoggingIn,
        loginError: state.appAuth.loginError
    };
};

export default connect(mapStateToProps)(Login);



// WEBPACK FOOTER //
// ./src/containers/Login/index.tsx